import React from "react";
import AppointmentsListTable from "../../../components/doctor-side-components/appointments-table/AppointmentsTable";

const Appointments = () => {
  return (
    <div className="p-4 ">
      <AppointmentsListTable />
    </div>
  );
};

export default Appointments;
